import diagramImage from "images/new/about-us-diagram.png";
import React from "react";

interface FounderQuoteSectionProps {
  className?: string;
}

const FounderQuoteSection: React.FC<FounderQuoteSectionProps> = ({ className = "" }) => {
  return (
    <section className={`relative w-full bg-gray-50 py-20 ${className}`}>
      <div className="container mx-auto">
        <div className="bg-white rounded-[32px] shadow-sm">
          <div className="flex flex-col md:flex-row items-start">
            {/* Content */}
            <div className="flex-grow p-12 md:p-16 max-w-[720px]">
              <div className="text-5xl font-bold mb-10">"</div>
              <div className="space-y-8">
                <p className="text-2xl text-gray-900 leading-relaxed">We've built a system that delivers on the FinVue promise – simplifying global transactions for individuals and businesses. But this is just the beginning.</p>
                <p className="text-2xl text-gray-900 leading-relaxed">
                  Our mission is to extend to reaching underserved regions while providing advanced features that streamline cross-border payments and multi-currency management. FinVue is committed to driving financial progress globally.
                </p>
                <p className="text-lg font-medium text-gray-500 mt-10">Founder</p>
              </div>
            </div>

            {/* Image */}
            <div className="flex-shrink-0 md:w-[480px] bg-gray-50 p-8 h-full m-6">
              <img src={diagramImage} alt="FinVue System Diagram" className="w-full h-auto" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderQuoteSection;
